// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#eb1426","primaryColorLight":"#e73140","primaryColorLighter":"#e87d86","primaryColorLightest":"#f1c0c4"};